export default {
	title: 'Risiken / Öffnungen',
	risks: 'Risiken',
	opportunities: 'Öffnungen',
	url: 'risiken',
	subtitle: '',
	all_categories: 'Kategorien-Filter',
	all_impacts: 'Auswirkungs-Filter',
	all_likelihoods: 'Wahrscheinlichkeits-Filter',
	all_stakeholders: 'Interessengruppen-Filter',
	all_stakes: 'Interessen-Filter',
	no_stakeholder: 'Keine Interessengruppe',
	tabs: {
		filters: {
			title: 'Ansichtsfilter',

			displayed_columns: 'Angezeigte Spalten',
			visualization_options: 'Visualisierungsoptionen'
		},
		options: {
			title: 'Anzeigen',
			are_links_visible: 'Alle Links anzeigen',
			show_description: 'Beschreibung anzeigen',
			chart_visible_stakes: 'Interessen anzeigen',
			chart_visible_stakeholders: 'Interessengruppen anzeigen',
			chart_visible_risks: 'Risiken anzeigen',
			chart_visible_opportunities: 'Öffnungen anzeigen'
		},
		general: {
			title: 'Allgemein'
		},
		stakeholders: {
			title: 'Stakeholder'
		},
		export: {
			title: 'Exportieren'
		},
		comments: {
			title: 'Verlauf'
		}
	},
	visualization_tab: 'Visualisierung',
	onboarding: {
		risks: {
			title: 'Risiken überprüfen',
			description:
				'Dies sind die Risiken, die auf Ihren Interessen lasten. Bewerten Sie ihre Wahrscheinlichkeit und ihre Auswirkung und korrigieren Sie diejenigen, die Ihnen falsch kalibriert erscheinen.'
		},
		opportunities: {
			title: 'Öffnungen überprüfen',
			description:
				'Im Gegensatz zu Risiken sind Öffnungen Dynamiken, die Ihre Interessen stärken können. Behalten Sie die umsetzbaren bei und legen Sie den Rest beiseite.'
		}
	}
};
